import React, { useState, useEffect, useCallback } from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import AddIcon from '@mui/icons-material/Add';
import Swal from 'sweetalert2'
import Setimage from './Setimage/setimage'
import Switch from '@mui/material/Switch';
import MyGoogleMap from './mapcomponent/MyGoogleMap'
import moment from 'moment'
import { IconButton } from '@mui/material';
import Rangepicker from './Rangepicker'
import RedpinIcon from '../../../assets/location.png'
import DeleteIcon from '@mui/icons-material/Delete';
import { confirmAlert } from 'react-confirm-alert'
import Hexapi from '../../../utility/HexAPI/Hexapi';
import { TimePicker } from '../../../components/calendar/Calender';
import { useDispatch, useSelector } from 'react-redux';
import LocationRangePickerModal from './LocationRangePickerModal';
import OrgLocationModal from './OrgLocationModal';
import TooltipButton from '../../../components/tooltip/Popover';
import { showConfirm } from '../../../utility/showconfirm';
import Loader from '../../../components/loader/Loader';

// ─── inline styles ────────────────────────────────────────────────────────────
const S = {
  page: {
    minHeight: '100vh',
    background: '#f7f8fa',
    padding: '2rem',
   
  },
  inner: {  margin: '0 auto' },

  // header
  header: {
    display: 'flex', alignItems: 'flex-start',
    justifyContent: 'space-between', borderBottom: '1px solid #eee', paddingBottom: 12,
  },
  headerLeft: {},
  pageTitle: {
    fontSize: 22, fontWeight: 600, color: '#111', letterSpacing: '-0.4px',
  },
  pageSub: { fontSize: 16, color: '#888', marginTop: 4 },

  saveBtn: {
    display: 'flex', alignItems: 'center', gap: 7,
    background: '#111', color: '#fff',
    border: 'none', borderRadius: 10,
    padding: '10px 20px', fontSize: 14, fontWeight: 500,
    cursor: 'pointer', transition: 'all 0.15s',
    boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
    flexShrink: 0,
  },

  // section label
  sectionLabel: {
    fontSize: 11, fontWeight: 600, letterSpacing: '0.08em',
    color: '#aaa', textTransform: 'uppercase',
    margin: '1.75rem 0 0.6rem',
  },

  row2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 },
  row1: { marginBottom: 12 , display: 'grid', gridTemplateColumns: '1fr 1fr', width:"100%"},

  fieldCard: (active, error) => ({
    background: '#fff',
    border: `1.5px solid ${error ? '#e44' : active ? '#111' : '#e8e8e8'}`,
    borderRadius: 12, padding: '14px 16px',
    transition: 'border-color 0.18s, box-shadow 0.18s',
    boxShadow: active ? '0 0 0 3px rgba(0,0,0,0.06)' : 'none',
    position: 'relative', cursor: 'text',
  }),
  fieldLabel: (error) => ({
    fontSize: 12, fontWeight: 600, letterSpacing: '0.07em',
    color: error ? '#e44' : 'black', textTransform: 'uppercase',
    display: 'flex', alignItems: 'center', gap: 4,
  }),
  fieldInput: {
    width: '100%', border: 'none', background: 'transparent',
    fontSize: 15, color: '#111', outline: 'none', 
  },
  fieldReadonly: {
    fontSize: 15, color: '#111', cursor: 'pointer',
    display: 'flex', alignItems: 'center', gap: 8,
  },
  chevron: { marginLeft: 'auto', color: '#ccc', flexShrink: 0 },
  locBadge: {
    display: 'inline-flex', alignItems: 'center', gap: 5,
    background: '#eaf4fb', color: '#1876c8',
    fontSize: 12, fontWeight: 500,
    padding: '3px 10px', borderRadius: 20,
  },

  // toggle cards
  toggleCard: (on) => ({
    background: on ? '#f0fdf8' : '#fff',
    border: `1.5px solid ${on ? '#b2ecd8' : '#e8e8e8'}`,
    borderRadius: 12, padding: '14px 16px',
    display: 'flex', alignItems: 'center',
    justifyContent: 'space-between', marginBottom: 8,
    cursor: 'pointer', transition: 'all 0.18s',
  }),
  toggleInfo: { flex: 1, paddingRight: 16 },
  toggleName: (on) => ({
    fontSize: 14, fontWeight: 500,
    color: on ? '#0a5c3a' : '#111',
  }),
  toggleDesc: { fontSize: 14, color: '#999', marginTop: 3, lineHeight: 1.5 },

  // photo zone
  photoZone: {
    background: '#fafafa',
    border: '2px dashed #e0e0e0',
    borderRadius: 12,
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center',
    minHeight: 140, gap: 6, cursor: 'pointer',
    transition: 'border-color 0.18s, background 0.18s',
  },
  photoLabel: { fontSize: 14, color: '#777', fontWeight: 500 },
  photoSub: { fontSize: 14, color: '#bbb' },

  // loading overlay
  loadingWrap: {
    display: 'flex', justifyContent: 'center',
    alignItems: 'center', height: 300,
  },
  emptyWrap: {
    display: 'flex', justifyContent: 'center',
    alignItems: 'center', height: 300,
  },

  // location modal
  locModal: { borderRadius: 16, overflow: 'hidden' },
  locHeader: {
    display: 'flex', alignItems: 'center',
    justifyContent: 'space-between',
    padding: '14px 18px',
    borderBottom: '1px solid #f0f0f0',
    fontWeight: 600, fontSize: 15,
  },
  locBody: { padding: '8px 0', maxHeight: 300, overflowY: 'auto' },
  locRow: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '11px 18px', cursor: 'pointer',
    transition: 'background 0.12s', borderBottom: '1px solid #f7f7f7',
  },
  locCoord: { fontSize: 13, color: '#555',  },
  locRange: {
    fontSize: 13, fontWeight: 500, color: 'red',
     padding: '2px 8px', borderRadius: 20,
  },
  locFooter: {
    padding: '12px 18px', borderTop: '1px solid #f0f0f0',
    display: 'flex', justifyContent:"center",
  },
  okBtn: {
    background: '#29b6f6', color: '#fff', border: 'none',
    borderRadius: 8, padding: '8px 22px',
    fontSize: 14, fontWeight: 500, cursor: 'pointer',
  },

  // range modal
  rangeHeader: {
    display: 'flex', alignItems: 'center',
    justifyContent: 'space-between',
    padding: '14px 18px', borderBottom: '1px solid #f0f0f0',
    fontWeight: 600, fontSize: 15,
  },
  rangeBody: { padding: '16px 18px' },
  rangeLocRow: {
    display: 'flex', alignItems: 'center', gap: 10,
    background: '#fafafa', borderRadius: 10, padding: '10px 14px',
    marginBottom: 18, cursor: 'pointer',
    border: '1px solid #eee', transition: 'background 0.12s',
  },
  rangeCoord: { fontSize: 13, color: '#444',  },
  rangeTitle: { fontSize: 13, color: '#888', marginBottom: 6 },
  rangeFooter: {
    padding: '12px 18px', borderTop: '1px solid #f0f0f0',
    display: 'flex', justifyContent: 'flex-end',
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr", // 👈 2 columns
    gap: "12px", // spacing between cards
  },

  toggleCard: (checked) => ({
    padding: "12px",
    borderRadius: "10px",
    border: checked ? "1px solid #4caf50" : "1px solid #ccc",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
    background: checked ? '#f0fdf8' : '#fff',
    border: `1.5px solid ${checked ? '#b2ecd8' : '#e8e8e8'}`,
    borderRadius: 12, padding: '14px 16px',
    display: 'flex', alignItems: 'center',
    justifyContent: 'space-between', marginBottom: 8,
    cursor: 'pointer', transition: 'all 0.18s',
  }),

  toggleInfo: {
    display: "flex",
    flexDirection: "column",
  },
};

// ─── tiny SVG icons ───────────────────────────────────────────────────────────
const IconSave = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
    <polyline points="17 21 17 13 7 13 7 21"/>
    <polyline points="7 3 7 8 15 8"/>
  </svg>
);
const IconPin = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);
const IconClock = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
    stroke="#aaa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </svg>
);
const IconChevron = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
    stroke="#ccc" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6"/>
  </svg>
);

// ─── custom MUI-style switch override via inline ──────────────────────────────
const CustomSwitch = ({ checked, onChange }) => (
  <Switch
    checked={checked}
    onChange={onChange}
    inputProps={{ 'aria-label': 'controlled' }}
    sx={{
      '& .MuiSwitch-switchBase.Mui-checked': { color: '#0a5c3a' },
      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#1D9E75' },
    }}
  />
);


export default function Settings() {
  const [attachmentid] = useState('0');
  const [orggpscoordinates, setOrggpscoordinates] = useState([]);
  const [isDataFound, setIsDataFound] = useState(false);
  const [isApiHitComplete, setIsApiHitComplete] = useState(false);
  const [orgNameError, setOrgNameError] = useState(false);
  const [orgName, setOrgName] = useState('');
  const [orgNameFocused, setOrgNameFocused] = useState(false);
  const [isOpenDailyReportTimeDatePicker, setIsOpenDailyReportTimeDatePicker] = useState(false);
  const [dailyReportTimeError, setDailyReportTimeError] = useState(false);
  const [dailyReportTime, setDailyReportTime] = useState('');
  const [orgLocationError, setOrgLocationError] = useState(false);
  const [isOpenOrgLocation, setIsOpenOrgLocation] = useState(false);
  const [orgLocation, setOrgLocation] = useState('');
  const [isCheckInOutChecked, setIsCheckInOutChecked] = useState(false);
  const [isLockCheckinTimeChecked, setIsLockCheckinTimeChecked] = useState(false);
  const [is_Limit_Shift_Closure_Time_Checked, setIs_Limit_Shift_Closure_Time_Checked] = useState(false);
  const [isSelfieChecked, setIsSelfieChecked] = useState(false);
  const [isOpenRangePicker, setIsOpenRangePicker] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [isOpenLocationPickerModal, setIsOpenLocationPickerModal] = useState(false);
  const [isLocationEdit, setIsLocationEdit] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [saveFeedback, setSaveFeedback] = useState(false);
  const [grouplist, setgrouplist] = useState([]);
  const user = useSelector(state => state?.users?.data?.[""]?.[0]);
  const dispatch = useDispatch();
  const userid = user?.empid ?? null;

  const setTime = (hours) => moment(`${hours}`, "hh").format('LT');

const setLocation = (str) => {
  if (!str || str === '-1') {
    setOrgLocation('0 location(s)');
    return [];
  }

  const locations = str.split('%%$#%%').filter(Boolean);

  const arr = locations.map((item, i) => {
    const parts = item.split('$#12$$');

    const latlng = parts?.[0] || '';
    const [lat, lng] = latlng.split(',');

    return {
      range: parts?.[1] || null,
      locationid: parts?.[2] || null,
      locationname: parts?.[3] || null,
      groupids: parts?.[4] || null,
      lat: lat ? parseFloat(lat) : null,
      lng: lng ? parseFloat(lng) : null,
    };
  });

  setOrgLocation(`${arr.length} location(s)`);
  return arr;
};

  const fetchOrgData = useCallback(() => {
    if (!userid) return;
    setIsDataFound(false);
    setIsApiHitComplete(false);
    const obj = {
      query: `HRApp_Droid_Proc_Organisation_Console_OrganisationSettings_GetValuev3 @UserID='{0}'`,
      queryArr: [`${userid}`],
    };
    Hexapi(obj).then(resp => {
      console.log(resp,"respjhng")
      if (resp?.['orgsettings']?.length > 0) {
        const org = resp['orgsettings'][0];
        console.log(org,"orghjkfgfvjhgbjvnkrcm")
        setDailyReportTime(setTime(org.dailyreporttime));
        setOrgName(org.organisationname);
        setIsCheckInOutChecked(Boolean(org.checkingpsactive));
        setIsLockCheckinTimeChecked(Boolean(org.limitcheckintime));
        setIs_Limit_Shift_Closure_Time_Checked(Boolean(org.lockshifttimefill));
        setIsSelfieChecked(Boolean(org.allselfieon));
        setOrggpscoordinates(setLocation(org.orggpscoordinates));
        setIsDataFound(true);
        setgrouplist(resp['grouplist'] ?? []);
      }
    }).then(() => setIsApiHitComplete(true));
  }, [userid]);

  useEffect(() => {
    new Promise((resolve, reject) => {
      const data = { header: `Organisation Settings` };
      const event = new CustomEvent('myCustomEvent', { detail: data });
      window.parent.document.dispatchEvent(event);
      event ? resolve() : reject('Header is not set');
    }).then(() => fetchOrgData()).catch(err => console.error(err));
  }, [fetchOrgData]);

  useEffect(()=>{
 if(orggpscoordinates.length == 0){
  setIsCheckInOutChecked(0)
 }
  },[orggpscoordinates])
  const onSaveSettings = () => {
    setOrgNameError(false);
    setDailyReportTimeError(false);
    setOrgLocationError(false);

    if (!orgName) {
      setOrgNameError(true);
      return Swal.fire({ confirmButtonColor: '#111', text: 'Enter Organization Name' });
    }
    if (dailyReportTime === 'Invalid Date') {
      setDailyReportTimeError(true);
      return Swal.fire({ confirmButtonColor: '#111', text: 'Enter a valid date' });
    }
    if (isCheckInOutChecked && orggpscoordinates.length === 0) {
      setOrgLocationError(true);
      return Swal.fire({ confirmButtonColor: '#111', text: 'Select a location' });
    }
    console.log(orggpscoordinates,"orggpscoordinates")
const coordinates = orggpscoordinates.length > 0
  ? orggpscoordinates.map(l => 
      `${l.lat},${l.lng}$#12$$${l.range}$#12$$${l.locationid}$#12$$${l.locationname}$#12$$${l.groupids}`
    ).join('%%$#%%')
  : '-1';

    setIsModalLoading(true);
    const obj = {
      query: `HRApp_Droid_Proc_Organisation_Console_OrganisationSettings_SubmitV7 @UserID='{0}',@OrganisationName='{1}'
        ,@CheckInGPSActive='{2}',@OrgGPSCoordinates='{3}',@LimitCheckInTime='{4}',@LockShiftTimeFill='{5}',@DailyReportTime='{6}'
        ,@AllSelfieOn='{7}'`,
      queryArr: [
        `${userid}`, `${orgName}`, `${isCheckInOutChecked ? 1 : 0}`,
        `${coordinates}`,
        `${isLockCheckinTimeChecked ? 1 : 0}`, `${is_Limit_Shift_Closure_Time_Checked ? 1 : 0}`,
        `${moment(dailyReportTime, ["h:mm A"]).format("HH")}`, `${isSelfieChecked ? 1 : 0}`,
      ],
    };

    Hexapi(obj).then(resp => {
      showConfirm({
        content:resp[''][0]['msg'],
        okText:"OK",
        hideCancel:true
      })
        .then(() => { if (resp[''][0]['command'] == 1) fetchOrgData(); });
    }).then(() => {
      setIsModalLoading(false);
      setSaveFeedback(true);
      setTimeout(() => setSaveFeedback(false), 2000);
    }).catch(err => console.error(err));
  };
const onLocationSelection = (lat, lng) => {
  let updatedLocations = [...orggpscoordinates];

  if (isLocationEdit) {
    updatedLocations = updatedLocations.map((loc) =>
      String(loc.locationid) === String(selectedLocation.locationid)
        ? {
            ...loc,
            lat,
            lng,
          }
        : loc
    );

    setSelectedLocation((prev) => ({
      ...prev,
      lat,
      lng,
    }));
  } else {

    const lastId =
      updatedLocations.length > 0
        ? Number(updatedLocations[updatedLocations.length - 1]?.locationid || 0)
        : 0;

    const obj = {
      locationid: -1, 
      lat,
      lng,
      locationname: "",
      range: 25,
      groupids: "-1",
    };

    updatedLocations = [...updatedLocations, obj];
    setSelectedLocation(obj);
  }

  setOrggpscoordinates(updatedLocations);
  setOrgLocation(updatedLocations.length + " location(s)");
  setIsOpenLocationPickerModal(false);
  setIsOpenRangePicker(true);
};

  const submitUserImage = (fileArr) => {
    setIsModalLoading(true);
    const obj = {
      query: `HRApp_Droid_Proc_User_SetPhotoV2 @EmpID='{0}',@Photo=$%$File$%$`,
      queryArr: [`${attachmentid}`],
      file: fileArr,
    };
    Hexapi(obj).then(resp => {
      Swal.fire({ confirmButtonColor: '#111', text: `${resp[''][0]['msg']}` });
    }).then(() => setIsModalLoading(false)).catch(err => console.error(err));
  };

const onDeleteLocation = () => {
  confirmAlert({
    message: 'Are you sure you want to delete this location?',
    buttons: [
      { label: 'No', onClick: () => {} },
      {
        label: 'Yes',
        onClick: () => {
          const filterArr = orggpscoordinates
            .filter(loc => loc.locationid !== selectedLocation.locationid);
          
          setOrggpscoordinates(filterArr);
          setOrgLocation(filterArr.length + ' location(s)');
          setIsOpenRangePicker(false);
        },
      },
    ],
    overlayClassName: "customOverlay",
  });
};

  const toggleConfigs = [
    {
      id: 'checkin', label: 'Check In/Out location',
      desc: "Enabling this will take employee's location on Check In/Out",
      checked: isCheckInOutChecked, onChange: async (e) => {
  if (e.target.checked && orggpscoordinates.length === 0) {
    const result = await showConfirm({
      content:"<b>Check-In Location</b><br/> Enabling Check In Location will make it mandatory for user to provide location permission to Check In </br> Are you sure you want to enable this ?",
      hideCancel:false,
      okText:"Yes",
      cancelText:"No"
    })

    if(result){
      setIsOpenOrgLocation(true)
    }
    return;
  }

  setIsCheckInOutChecked(e.target.checked);
},
    },
    {
      id: 'locktime', label: 'Lock CheckIn Time',
      desc: "Enabling this will only allow CheckIn Based on employee's shift configuration",
      checked: isLockCheckinTimeChecked, onChange: (e) => setIsLockCheckinTimeChecked(e.target.checked),
    },
    {
      id: 'shiftclosure', label: 'Limit Shift Closure Time',
      desc: "Enabling this will not allow employee to fill duration more than duration between CheckIn and checkOut time",
      checked: is_Limit_Shift_Closure_Time_Checked, onChange: (e) => setIs_Limit_Shift_Closure_Time_Checked(e.target.checked),
    },
    {
      id: 'selfie', label: 'Selfie On Check In/Out',
      desc: "Enabling this will ask all employees to take selfie on Check In/Out",
      checked: isSelfieChecked, onChange: (e) => setIsSelfieChecked(e.target.checked),
    },
  ];

  // ── render ──────────────────────────────────────────────────────────────────
  return (
    <>
      <div style={S.page}>
        <div style={S.inner}>
          <div style={S.header}>
            <div style={S.headerLeft}>
              {/* <div style={S.pageSub}>Manage your organisation preferences and check-in/out policies</div> */}
            </div>
            
            <button
              style={{
                ...S.saveBtn,
                background: saveFeedback ? '#1D9E75' : '#29b6f6',
              }}
              onClick={onSaveSettings}
            >
              <IconSave />
              {saveFeedback ? '✓ Saved!' : 'Save changes'}
            </button>
          </div>

          {/* ── content ── */}
          {!isApiHitComplete ? (
            <div style={S.loadingWrap}><Spinner animation="border" variant="dark" /></div>
          ) : !isDataFound ? (
            <div style={S.emptyWrap}><h5 style={{ color: '#f90' }}>No Records!</h5></div>
          ) : (
            <div style={{height:"80vh" , overflowY:"auto" , scrollbarWidth:"none" , paddingBottom:"20vh" , paddingTop:"10px"}}>
              {/* ── fields row ── */}
               <div style={S.row1}>
                <Setimage
                  attachmentbutton={true}
                  camerabutton={true}
                  showphoto={true}
                  imagecallback={(e) => submitUserImage(e)}
                  isImageSelected={(e) => console.log(e)}
                  attachmentid={attachmentid}
                />
                <div className='d-flex flex-column gap-2'>
                 
                <div style={S.fieldCard(orgNameFocused, orgNameError)}>
                  <div style={S.fieldLabel(orgNameError)}>Organisation name <span style={{ color: '#e44' }}>*</span> <TooltipButton isfont={true} fieldName={"OrganisationName"}/></div>
                  <input
                    style={S.fieldInput}
                    type="text"
                    placeholder="e.g. Techy Shah"
                    value={orgName}
                    onChange={(e) => { setOrgName(e.target.value); setOrgNameError(false); }}
                    onFocus={() => setOrgNameFocused(true)}
                    onBlur={() => setOrgNameFocused(false)}
                  />
                </div>
               
                <div
                  style={{ ...S.fieldCard(false, dailyReportTimeError), cursor: 'pointer' }}
                  onClick={() => setIsOpenDailyReportTimeDatePicker(true)}
                >
                  <div style={S.fieldLabel(dailyReportTimeError)}>Daily report time <span style={{ color: '#e44' }}>*</span> <TooltipButton isfont={true}  fieldName={"OrganisationReportTime"}/></div>
                  <div style={{ ...S.fieldReadonly }}>
                    <IconClock />
                    <span style={{ fontSize: 15, color: '#111' }}>{dailyReportTime || '—'}</span>
                    <span style={S.chevron}><IconChevron /></span>
                  </div>
                </div>

<div
                  style={{ ...S.fieldCard(false, orgLocationError), cursor: 'pointer' }}
                  onClick={() => setIsOpenOrgLocation(true)}
                >
                  <div style={S.fieldLabel(orgLocationError)}>Organisation locations <span style={{ color: '#e44' }}>*</span> <TooltipButton isfont={true} fieldName={"OrganisationLocation"}/></div>
                  <div style={{ ...S.fieldReadonly }}>
                    <span style={S.locBadge}>
                     {orgLocation && <IconPin />}  {orgLocation || 'Select Location'}
                    </span>
                    <span style={S.chevron}><IconChevron /></span>
                  </div>
                </div>
                </div>
              </div>
              <div style={S.row2}>
                                
              </div>
              
              <div style={S.gridContainer}>
  {toggleConfigs.map(t => (
    <div
      key={t.id}
      style={S.toggleCard(t.checked)}
      onClick={() =>
        t.onChange({ target: { checked: !t.checked } })
      }
    >
      <div style={S.toggleInfo}>
        <div style={S.toggleName(t.checked)}>{t.label}</div>
        <div style={S.toggleDesc}>{t.desc}</div>
      </div>

      <div onClick={e => e.stopPropagation()}>
        <CustomSwitch checked={t.checked} onChange={t.onChange} />
      </div>
    </div>
  ))}
</div>

            
            </div>
          )}
        </div>
      </div>

      {/* ── map picker modal ── */}
      <Modal
        show={isOpenLocationPickerModal}
        onHide={() => setIsOpenLocationPickerModal(false)}
        keyboard={false}
        backdrop="static"
        style={{ backgroundColor: "rgba(0,0,0,0.85)" }}
        centered fullscreen
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 16, fontWeight: 600 }}>Location Picker</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MyGoogleMap SelectedLocation={{ 
    lat: selectedLocation?.lat,   
    lng: selectedLocation?.lng    
  }}  latlag={(lat, lng) => onLocationSelection(lat, lng)} />
        </Modal.Body>
      </Modal>

      {/* ── loading modal ── */}
      <Modal
        size="sm" centered
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
        show={isModalLoading}
        onHide={() => setIsModalLoading(false)}
        backdrop="static" keyboard={false}
      >
        <Modal.Body>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 80 }}>
           <Loader/>
          </div>
        </Modal.Body>
      </Modal>

     {isOpenDailyReportTimeDatePicker && (
  <TimePicker
    openTimePicker={isOpenDailyReportTimeDatePicker}
    onHideTimePicker={() => setIsOpenDailyReportTimeDatePicker(false)}
    onChange={(time) => {
      setDailyReportTime(moment(time).format("LT"));
      setIsOpenDailyReportTimeDatePicker(false);
      setDailyReportTimeError(false);
    }}
    defaults={
      dailyReportTime
        ? moment(dailyReportTime, ["h:mm A"])
        : new Date()
    }
  />
)}

     <OrgLocationModal
  isOpenOrgLocation={isOpenOrgLocation}
  setIsOpenOrgLocation={setIsOpenOrgLocation}
  setIsOpenLocationPickerModal={setIsOpenLocationPickerModal}
  setIsLocationEdit={setIsLocationEdit}
  orggpscoordinates={orggpscoordinates}
  setSelectedLocation={setSelectedLocation}
  setIsOpenRangePicker={setIsOpenRangePicker}
  S={S}
  RedpinIcon={RedpinIcon}
/>

     <LocationRangePickerModal
  isOpen={isOpenRangePicker}
  setOrggpscoordinates={setOrggpscoordinates}
  onClose={() => setIsOpenRangePicker(false)}
  selectedLocation={selectedLocation}
  onDeleteLocation={onDeleteLocation}
  onEditLocation={() => {
    setIsLocationEdit(true);
    setIsOpenLocationPickerModal(true);
    setIsOpenRangePicker(false);
  }}
  grouplist={grouplist.length > 0 ? grouplist : []}
  orggpscoordinates={orggpscoordinates}
/>
    </>
  );
}
